// extracted by mini-css-extract-plugin
export default {"isolated":"TagList_isolated__RTy+q","tagItemIsolated":"TagList_tagItemIsolated__0yPWO"};